export { default as MatomoContext } from './MatomoContext';
export { default as MatomoProvider } from './MatomoProvider';
export { default as createInstance } from './instance';
export { default as useMatomo } from './useMatomo';
//# sourceMappingURL=index.js.map